export default __webpack_public_path__ + "static/media/fi_phone.f45a4623.svg";